import React, {useEffect} from 'react';
import "./Index.scss";
import Banner from "./components/Banner/Banner";
import Products from "./components/Products/Products";
import {ProductVideos} from "./components/ProductVideos/ProductVideos";
import {SubmitInfo} from "../../components/SubmitInfo/SubmitInfo";
import {Slogen} from "./components/Slogen/Slogen";
import {Service} from "./components/Service/Service";
import {Footer} from "../../components/Footer";
import {useScrollHeader} from "../../utils/headerHelper";

export function Index() {

    useScrollHeader();
    return <>
        <div style={{paddingTop: '82px'}}>
            <Banner/>
            <Slogen/>
            <Products/>
            <Service/>
            <ProductVideos/>
            <SubmitInfo/>
        </div>
        <Footer/>
    </>
}
